import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BlockErrors, CheckboxItem, InputGroupBase } from '@/components';
import { useResolveValue } from '@/hooks';
import { InputBlockType, ValuesType } from '@/types';
import { filterBlockAnswers, getInputBlockAnswer } from '@/utils';
import { BlockLayout } from '../fragments/BlockLayout';
export const RadioGroup = ({ block: { answer_filters = [], answers = [], id, images = [], key, layout, type }, defaultValue = '', errors = [], onChange }) => {
    const [resolver] = useResolveValue();
    const resolved = useMemo(() => {
        const answerKeys = resolver.resolveAnswerFilter(answer_filters);
        const filters = filterBlockAnswers(answers, answerKeys, defaultValue);
        const answersList = filters.answersFiltered.map((a, order) => {
            return Object.assign(Object.assign({}, a), { label: resolver.resolveString(a.label), order });
        });
        return {
            answersList
        };
    }, []);
    const handleChange = (answer) => {
        let valueType;
        switch (type) {
            case InputBlockType.INPUT_INTEGER_RADIO_GROUP:
                valueType = ValuesType.INTEGER;
                break;
            case InputBlockType.INPUT_RANGE_RADIO_GROUP:
                valueType = ValuesType.RANGE;
                break;
            case InputBlockType.INPUT_STRING_RADIO_GROUP:
                valueType = ValuesType.STRING;
                break;
        }
        const newAnswer = getInputBlockAnswer(valueType, answer, key);
        onChange(newAnswer, { order: answer.order });
    };
    return (_jsx(BlockErrors, Object.assign({ errors: errors }, { children: _jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(InputGroupBase, Object.assign({ "data-test": id }, { children: resolved.answersList.map((item) => {
                    const value = JSON.stringify(item.value);
                    const isChecked = defaultValue !== undefined &&
                        defaultValue !== null &&
                        value === JSON.stringify(defaultValue);
                    return (_jsx(CheckboxItem, { answer: item, answerChange: handleChange, images: images, isChecked: isChecked }, item.id));
                }) })) })) })));
};
